import { Flex } from '@chakra-ui/react';
import { FormFeedback, OutlineCard, Input } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FormFieldClinicalTrials } from '@publishing-engine/domain/types/article';
import { RadioGroup } from 'src/components/RadioGroup';

const ClinicalTrials = ({ config }: { config: FormFieldClinicalTrials }) => {
  const {
    formState: { errors },
    register,
    watch,
    control
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field, dependsOn }
  } = config;
  const dependsOnField = `${field}.${dependsOn}` as const;
  const mainField = `${field}.value` as const;

  const error = get(errors, field);

  const exists = watch(dependsOnField);
  const clinicalTrials = watch(mainField);

  return (
    <Flex flexDirection="column" gap={8} width="100%">
      <OutlineCard padding={4}>
        <Flex flexDirection="column" gap={4}>
          <FieldLabel
            isRequired={validations.required}
            label={labels.main}
            subText={labels.subtitle}
          />

          <Flex flexDirection="column" gap={4}>
            <RadioGroup
              name={dependsOnField}
              control={control}
              options={[
                {
                  value: true,
                  children: labels.options['true']?.main
                },
                {
                  value: false,
                  children: labels.options['false']?.main
                }
              ]}
            />
          </Flex>

          {exists ? (
            <Flex flexDirection="column" gap={2}>
              <FieldLabel
                label={labels.section.title}
                subText={labels.section.explanation}
                isRequired
              />

              <Input
                placeholder="eg., NCT00000000"
                value={clinicalTrials || ''}
                isInvalid={Boolean(error?.value)}
                {...register(mainField)}
              />
              {error?.value && (
                <FormFeedback variant="error">
                  Please enter the clinical trial registration number
                </FormFeedback>
              )}
            </Flex>
          ) : null}

          {error?.[dependsOn] ? (
            <FormFeedback variant="error">
              Please indicate whether your submission includes clinical trials
              to proceed
            </FormFeedback>
          ) : null}
        </Flex>
      </OutlineCard>
    </Flex>
  );
};

export default ClinicalTrials;
